import { buildPlatformScope } from '@examflow/core';
import {
  buildAttemptHref,
  buildScopedLearningHref,
  type ExamCode,
  type TrainingIntensity,
} from '@examflow/learning-space';

function intensityFromQuestionCount(count: number): TrainingIntensity {
  if (count <= 6) return 'short';
  if (count <= 12) return 'standard';
  return 'full';
}

/**
 * Retention entry: never open a thin /quiz without AttemptSpec.
 * Prefer a Training Session for the question's skill; otherwise Exam Space.
 */
export function buildRetentionQuizHref(input: {
  languageId?: string | null;
  examType?: string | null;
  skillId?: string | null;
  questionCount?: number;
}): string {
  const examTypeRaw = input.examType?.trim().toLowerCase() || null;
  const skillId = input.skillId?.trim().toLowerCase() || null;
  const scope = buildPlatformScope({
    languageId: input.languageId,
    examType: examTypeRaw,
  });

  if (!scope) {
    return '/workspace';
  }

  if (!skillId) {
    return buildScopedLearningHref('/workspace', {
      languageId: scope.languageId,
      examType: scope.examType,
    });
  }

  try {
    return buildAttemptHref({
      kind: 'training',
      languageId: scope.languageId,
      examType: scope.examType as ExamCode,
      skillId,
      intensity: intensityFromQuestionCount(input.questionCount ?? 6),
    });
  } catch {
    return buildScopedLearningHref('/workspace', {
      languageId: scope.languageId,
      examType: scope.examType,
    });
  }
}
